import Storage from '@/utils/storage';

// 退出到登录页面
const excludeStorageList = [
  'collapsed', // 左侧导航折叠
  'screenZoomIndex', // 页面缩放比例
  'fullScreenFlag', // 全屏标识
  'INTL_USER_SETTING_CONFIG', // 用户多语言配置
];

export const logoutToLogin = () => {
  const excludeData = {};
  excludeStorageList.forEach((item) => {
    const localVal = Storage.get(item);
    if (localVal) {
      excludeData[item] = localVal;
    }
  });
  Storage.clear();
  excludeStorageList.forEach((item) => {
    if (excludeData[item]) {
      Storage.set(item, excludeData[item]);
    }
  });
  window.location.href = '/login';
};
